import { Component } from '@angular/core';
import { EChartsOption } from 'echarts';

@Component({
	selector: 'app-dashboard-chart-line',
	standalone: false,
	templateUrl: './dashboard-chart-line.component.html',
	styleUrl: './dashboard-chart-line.component.scss'
})
export class DashboardChartLineComponent {
	options: EChartsOption = {
		tooltip: { trigger: 'axis' },
		xAxis: { data: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'] },
		yAxis: {},
		series: [{
			type: 'line',
			smooth: true,
			data: [80, 95, 110, 130, 125, 160]
		}]
	};
}
